import React, { useEffect } from 'react';
import { useAuth } from './hooks/useAuth';
import LoginPage from './pages/LoginPage';
import Dashboard from './pages/Dashboard';
import './index.css';

/**
 * Root application component. Renders the login page until authenticated.
 */
function App() {
  const { isAuthenticated, login, logout } = useAuth();

  // Auto-logout when any API call returns 401 (expired token)
  useEffect(() => {
    window.addEventListener('auth:unauthorized', logout);
    return () => window.removeEventListener('auth:unauthorized', logout);
  }, [logout]);

  if (!isAuthenticated) {
    return <LoginPage onLogin={login} />;
  }

  return <Dashboard onLogout={logout} />;
}

export default App;
